import { render, staticRenderFns } from "./ToolbarHeader.vue?vue&type=template&id=1ec2cef6&scoped=true&"
import script from "./ToolbarHeader.vue?vue&type=script&lang=js&"
export * from "./ToolbarHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec2cef6",
  null
  
)

export default component.exports